import React from "react";
import { TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { styles } from "./styles";

export const NavButton = props => {
  const { onPress, disabled, left, hide } = props;
  const icon = left ? "caret-left" : "caret-right";
  return (
    <TouchableOpacity
      style={[
        styles.button,
        disabled && { opacity: 0.3 },
        hide && { opacity: 0 },
        left ? styles.left : styles.right,
      ]}
      disabled={disabled}
      activeOpacity={hide ? 0 : 0}
      onPress={hide ? undefined : onPress}
    >
      <Icon
        name={icon}
        size={styles._icon && styles._icon.fontSize}
        color={styles._icon && styles._icon.color}
      />
    </TouchableOpacity>
  );
};
